import { API } from "@/services"

export const AGENTS_ENDPOINTS = {
  serverRegisterAgents(params={}){
    return API.Axios.error_capture.v1.request({
      url: `agents/server-register-agents`,
      method: 'GET',
      params,
    })
  },
  serverTotalRegisterAgents(params={}){
    return API.Axios.error_capture.v1.request({
      url: `agents/server-total-register-agents`,
      method: 'GET',
      params,
    })
  },
  serverUniqueRegisterAgents(params={}){
    return API.Axios.error_capture.v1.request({
      url: `agents/server-unique-register-agents`,
      method: 'GET',
      params,
    })
  },
  list(params={}){
    return API.Axios.error_capture.v1.request({
      url: `agents`,
      method: 'GET',
      params,
    })
  },
}